import { ReceiptRoot } from './block-chain-types';

export type JobStatus =
    | 'NEW'
    | 'QUEUED'
    | 'RUNNING'
    | 'CANCELLED'
    | 'COMPLETED_ERROR'
    | 'INCOMPLETE_ERROR'
    | 'COMPLETED_SUCCESS';
export type JobType =
    | 'DbSchemaUploadJob'
    | 'FileUploadJob'
    | 'FileDownloadJob'
    | 'SmartContractExecJob'
    | 'TruncateChainJob'
    | 'DictionaryUploadJob'
    | 'ResetSDZJob'
    | 'WipeSDZDataJob'
    | 'GlossaryUploadJob'
    | 'GlossaryDownloadJob'
    | 'DropChainJob'
    | 'ExportDownloadJob';

interface Metadata {
    [key: string]: string;
}

interface MDC {
    [key: string]: string;
}

export interface Result {
    [key: string]: any;
}

interface Results {
    results?: Result;
    error?: string;
}

export interface JobSummary {
    name: JobType;
    jobId: string;
    status: JobStatus;
    jobCreated: string;
    jobQueued: string;
    jobStarted: string;
    jobCompleted: string;
    dictName: string;
    loggedInId: string;
    fileType?: string;
    results: Results;
    downloadedDate?: string;
    downloadedWalletId?: string;
}

export interface JobData {
    jobs: JobSummary[];
    limit: number;
    skip: number;
    total: number;
}

export interface Job {
    clazz: string;
    customerName: string;
    dataSize?: number;
    dictName?: string;
    delete?: boolean;
    effectiveId: string;
    emailRecipients?: string[];
    jobCompleted: string;
    jobCreated: string;
    jobId: string;
    jobQueued: string;
    jobStarted: string;
    key: string;
    loggedInId: string;
    mdc?: MDC;
    metadata?: Metadata;
    name: JobType;
    numThreads?: number;
    originalFilename: string;
    results: Results;
    sdzName: string;
    status: JobStatus;
    timeout: number;
    timeoutUnit: string;
    chainName?: string;
    owners?: string[];
    func?: string;
    receipt: ReceiptRoot;
    sdoId?: string;
    fileType?: string;
}

export const getJobDetailsType = (type: JobType): string => {
    switch (type) {
        case 'FileUploadJob':
            return 'Upload Data';
        case 'TruncateChainJob':
            return 'Truncate a Chain';
        case 'DictionaryUploadJob':
            return 'Import Dictionary';
        case 'SmartContractExecJob':
            return 'Execute Smart Contract';
        case 'DbSchemaUploadJob':
            return 'Import DbSchema';
        case 'FileDownloadJob':
            return 'Download Data';
        case 'ResetSDZJob':
            return 'Reset SDZ';
        case 'WipeSDZDataJob':
            return 'Wipe SDZ Data';
        case 'GlossaryUploadJob':
            return 'Import Glossary';
        case 'GlossaryDownloadJob':
            return 'Export Glossary';
        case 'DropChainJob':
            return 'Drop a Chain';
        case 'ExportDownloadJob':
            return 'Export Data';
        default:
            return type;
    }
};
